module.exports = __webpack_public_path__ + "media/flags/br-982a3b57.svg";